import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { GlobalStyles } from './design-system/GlobalStyles';
import { ThemeProvider } from './design-system/ThemeProvider';
import './index.css';
import { ApiProvider } from './services/api/ApiProvider';
import { SocketProvider } from './services/socket/SocketContext';
import { PixiAppProvider } from './services/pixiApp/pixiAppProvider';
import { AuthProvider } from './services/auth/authProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <SocketProvider>
    <ApiProvider>
      <PixiAppProvider>
        <AuthProvider>
          <BrowserRouter>
            <ThemeProvider>
              <GlobalStyles />
              <App />
            </ThemeProvider>
          </BrowserRouter>
        </AuthProvider>
      </PixiAppProvider>
    </ApiProvider>
  </SocketProvider>
);
